"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.OUT_SCENE_EFFECT = exports.IN_SCENE_EFFECT = exports.CONTENT_POSITION = exports.OPACITY_LAYOUT_COLORS = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.custom-link"));

var _gerenciatdUtils = require("@bit/gerenciatd.utils.style-utils");

require("./Modal.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

let modalRoot = null;
const OPACITY_LAYOUT_COLORS = {
  BLACK: 'black',
  WHITE: 'white',
  BLACK05: 'black05',
  TRANSPARENT: 'transparent'
}; // XPOSITION_ YPOSITION

exports.OPACITY_LAYOUT_COLORS = OPACITY_LAYOUT_COLORS;
const CONTENT_POSITION = {
  // absolutelly center
  CENTER_CENTER: 'center--center',
  LEFT_CENTER: 'left--center',
  RIGHT_CENTER: 'right--center',
  // vertically top
  CENTER_TOP: 'center--top',
  RIGHT_TOP: 'right--top',
  LEFT_TOP: 'left--top',
  // vertically bottom
  CENTER_BOTTOM: 'center--bottom',
  RIGHT_BOTTOM: 'right--bottom',
  LEFT_BOTTOM: 'left--bottom'
};
exports.CONTENT_POSITION = CONTENT_POSITION;
const IN_SCENE_EFFECT = {
  FADE_IN: 'fadeIn',
  FADE_IN_LEFT: 'fadeInLeft',
  FADE_IN_RIGHT: 'fadeInRight',
  FADE_IN_TOP: 'fadeInTop',
  FADE_IN_BOTTOM: 'fadeInBottom'
};
exports.IN_SCENE_EFFECT = IN_SCENE_EFFECT;
const OUT_SCENE_EFFECT = {
  FADE_OUT: 'fadeOut',
  FADE_OUT_LEFT: 'fadeOutLeft',
  FADE_OUT_RIGHT: 'fadeOutRight',
  FADE_OUT_TOP: 'fadeOutTop',
  FADE_OUT_BOTTOM: 'fadeOutBottom'
};
exports.OUT_SCENE_EFFECT = OUT_SCENE_EFFECT;

class SgnModal extends _react.Component {
  static show() {
    SgnModal.__singletonRef.__show();
  }

  static hide() {
    SgnModal.__singletonRef.__hide();
  }

  static setContent(component) {
    SgnModal.__singletonRef.__setContent(component);
  }

  static setModalProps(props) {
    SgnModal.__singletonRef.__setModalProps(props);
  }

  constructor(props) {
    super(props);

    _defineProperty(this, "componentDidUpdate", () => {
      const {
        show,
        unMounted
      } = this.state;

      if (!show && !unMounted) {
        const transitionEvent = (0, _gerenciatdUtils.whichAnimationEvent)();
        const element = document.getElementById('animationReference');

        if (transitionEvent) {
          element.addEventListener(transitionEvent, () => {
            // hide modal root
            modalRoot.classList.remove('visible');
            this.setState({
              unMounted: true
            });
          });
        }
      }
    });

    _defineProperty(this, "createContentCss", (contentPosition, inSceneEffect, outSceneEffect, show, className) => {
      const cssContentPosition = contentPosition ? `Modal_content Modal_content--${contentPosition}` : '';
      let sceneCss = inSceneEffect ? ` Modal_content--${contentPosition}--${inSceneEffect}` : '';

      if (!show) {
        sceneCss = outSceneEffect ? ` Modal_content--${contentPosition}--${outSceneEffect}` : '';
      }

      const cssOwnClassName = className ? ` ${className}` : '';
      return `${cssContentPosition}${sceneCss}${cssOwnClassName}`;
    });

    _defineProperty(this, "createOpacityLayoutCss", (opacityLayoutColor, show) => {
      let cssOpacityLayout = `Single_Modal opacity_layout opacity_layout--${opacityLayoutColor} Single_Modal--fadeIn`;

      if (!show) {
        cssOpacityLayout = `Single_Modal opacity_layout opacity_layout--${opacityLayoutColor} Single_Modal--fadeOut`;
      }

      return cssOpacityLayout;
    });

    _defineProperty(this, "handleCloseOnLayout", () => {
      const {
        closeByClickingOutside,
        onCloseHandler
      } = this.state;

      if (closeByClickingOutside) {
        const myInstance = this.constructor;
        myInstance.hide();

        if (onCloseHandler) {
          onCloseHandler();
        }
      }
    });

    _defineProperty(this, "setScrollOnElements", scrollValue => {
      const body = document.getElementsByTagName('body')[0];
      const html = document.getElementsByTagName('html')[0];
      body.style.overflowY = scrollValue;
      html.style.overflowY = scrollValue;
    });

    _defineProperty(this, "renderModalContent", (contentInsideContainer, content, contentCss) => {
      if (contentInsideContainer) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "xux",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: `${contentCss}`,
              children: content
            })
          })
        });
      }

      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: `${contentCss}`,
        children: content
      });
    });

    const {
      projectId
    } = props;

    if (projectId) {
      const appDiv = document.getElementById(projectId);

      if (appDiv) {
        modalRoot = appDiv.getElementsByClassName('modal-root');

        if (modalRoot && modalRoot.length > 0) {
          modalRoot = modalRoot[0];
        } else {
          modalRoot = document.getElementById('modal-root');
        }
      }
    } else {
      modalRoot = document.getElementById('modal-root');
    } // TEngo que encontrar mi hueco


    const {
      opacityLayoutColor: _opacityLayoutColor,
      contentPosition: _contentPosition,
      className: _className,
      inSceneEffect: _inSceneEffect,
      outSceneEffect: _outSceneEffect,
      closeByClickingOutside: _closeByClickingOutside,
      taggingInfoWhenClickingOutside,
      contentInsideContainer: _contentInsideContainer,
      scrollAllowed,
      onCloseHandler: _onCloseHandler
    } = props;
    SgnModal.__singletonRef = this;
    this.state = {
      unMounted: true,
      show: false,
      className: _className,
      inSceneEffect: _inSceneEffect,
      outSceneEffect: _outSceneEffect,
      contentPosition: _contentPosition,
      opacityLayoutColor: _opacityLayoutColor,
      closeByClickingOutside: _closeByClickingOutside,
      taggingInfoWhenClickingOutside,
      contentInsideContainer: _contentInsideContainer,
      scrollAllowed,
      onCloseHandler: _onCloseHandler
    };
  }
  /* this handle transition and unmounted event */


  __setContent(content) {
    this.setState({
      content
    });
  }

  __setModalProps(props) {
    const {
      scrollAllowed,
      show
    } = props;

    if (scrollAllowed) {
      this.setScrollOnElements('auto');
    }

    if (typeof show !== 'undefined' && show) {
      this.__show();
    }

    if (typeof show !== 'undefined' && !show) {
      this.__hide();
    }

    this.setState(_objectSpread({}, props));
  }

  __show() {
    const {
      scrollAllowed
    } = this.state; // show modal-root

    modalRoot.classList.add('visible'); // disallow scroll on html,body

    if (!scrollAllowed) {
      this.setScrollOnElements('hidden');
    } else {
      this.setScrollOnElements('auto');
    } // set properties


    this.setState({
      show: true,
      unMounted: false
    });
  }

  __hide() {
    // disallow scroll on html,body
    this.setScrollOnElements('auto');
    this.setState({
      show: false
    });
  }

  render() {
    const {
      opacityLayoutColor,
      contentPosition,
      className,
      inSceneEffect,
      outSceneEffect,
      unMounted,
      contentInsideContainer,
      taggingInfoWhenClickingOutside
    } = this.state;
    const {
      show,
      content
    } = this.state;
    const cssOpaticyLayout = this.createOpacityLayoutCss(opacityLayoutColor, show);
    const contentCss = this.createContentCss(contentPosition, inSceneEffect, outSceneEffect, show, className);

    if (!show && unMounted || !content) {
      return null;
    }

    return /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
      children: [this.renderModalContent(contentInsideContainer, content, contentCss), taggingInfoWhenClickingOutside && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
        id: "animationReference",
        isBlockElement: true,
        className: cssOpaticyLayout,
        onClick: this.handleCloseOnLayout,
        onKeyPress: this.handleCloseOnLayout,
        taggingInfo: taggingInfoWhenClickingOutside
      }), !taggingInfoWhenClickingOutside && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        id: "animationReference",
        role: "button",
        tabIndex: "-1",
        className: cssOpaticyLayout,
        onClick: this.handleCloseOnLayout,
        onKeyPress: this.handleCloseOnLayout
      })]
    }), modalRoot);
  }

}

SgnModal.propTypes = {
  /**
   * {
   *  "info": "Define la clase CSS custom que se aplicará al componente",
   *  "kind": "both",
   *  "beautifulName": "Estilos custom"
   * }
   */
  className: _propTypes.default.string,

  /**
   * {
   *  "info": "Establece si la modal puede ser cerrada al hacer click fuera de ella",
   *  "kind": "both",
   *  "beautifulName": "Cerrar con click fuera"
   * }
   */
  closeByClickingOutside: _propTypes.default.bool,

  /**
   * {
   *  "info": "Establece si la modal puede ser cerrada al hacer click fuera de ella",
   *  "kind": "both",
   *  "beautifulName": "Cerrar con click fuera"
   * }
   */
  taggingInfoWhenClickingOutside: _propTypes.default.object,

  /**
   * {
   *  "info": "Define la posición que ocupará la modal al ser lanzada",
   *  "kind": "both",
   *  "beautifulName": "Posición"
   * }
   */
  contentPosition: _propTypes.default.oneOf([CONTENT_POSITION.CENTER_CENTER, CONTENT_POSITION.CENTER_TOP, CONTENT_POSITION.RIGHT_TOP, CONTENT_POSITION.LEFT_TOP, CONTENT_POSITION.CENTER_BOTTOM]),

  /**
   * {
   *  "info": "Define el color de background de la capa layout que cubre la pantalla bajo la modal",
   *  "kind": "both",
   *  "beautifulName": "Estilos layout"
   * }
   */
  opacityLayoutColor: _propTypes.default.oneOf([OPACITY_LAYOUT_COLORS.BLACK, OPACITY_LAYOUT_COLORS.WHITE, OPACITY_LAYOUT_COLORS.BLACK05, OPACITY_LAYOUT_COLORS.TRANSPARENT]),

  /**
   * {
   *  "info": "Define el efecto con el que se mostrará la modal al ser lanzada",
   *  "kind": "both",
   *  "beautifulName": "Efecto de apertura"
   * }
   */
  inSceneEffect: _propTypes.default.oneOf([IN_SCENE_EFFECT.FADE_IN, IN_SCENE_EFFECT.FADE_IN_LEFT, IN_SCENE_EFFECT.FADE_IN_RIGHT, IN_SCENE_EFFECT.FADE_IN_TOP, IN_SCENE_EFFECT.FADE_IN_BOTTOM]),

  /**
   * {
   *  "info": "Define el efecto con el que se ocultará la modal al ser cerrada",
   *  "kind": "both",
   *  "beautifulName": "Efecto de cierre"
   * }
   */
  outSceneEffect: _propTypes.default.oneOf([OUT_SCENE_EFFECT.FADE_OUT, OUT_SCENE_EFFECT.FADE_OUT_LEFT, OUT_SCENE_EFFECT.FADE_OUT_RIGHT, OUT_SCENE_EFFECT.FADE_OUT_BOTTOM, OUT_SCENE_EFFECT.FADE_OUT_TOP]),

  /**
   * {
   *  "info": "Define si la modal se tiene que mostrar dentro del elemento container de la página o fuera de el",
   *  "kind": "both",
   *  "beautifulName": "Dentro de container"
   * }
   */
  contentInsideContainer: _propTypes.default.bool,

  /**
   * {
   *  "info": "Define si la modal permite scroll",
   *  "kind": "both",
   *  "beautifulName": "Scrollable"
   * }
   */
  scrollAllowed: _propTypes.default.bool,

  /**
  * {
  *  "info": "Método que se ejecuta al hacer click fuera del modal",
  *  "kind": "both",
  *  "beautifulName": "Método de cierre"
  * }
  */
  onCloseHandler: _propTypes.default.func
};
SgnModal.defaultProps = {
  className: '',
  closeByClickingOutside: false,
  taggingInfoWhenClickingOutside: null,
  contentPosition: CONTENT_POSITION.CENTER_BOTTOM,
  opacityLayoutColor: OPACITY_LAYOUT_COLORS.BLACK,
  inSceneEffect: IN_SCENE_EFFECT.FADE_IN,
  outSceneEffect: OUT_SCENE_EFFECT.FADE_OUT,
  contentInsideContainer: false,
  scrollAllowed: false,
  onCloseHandler: null
};
var _default = SgnModal;
exports.default = _default;

//# sourceMappingURL=index.js.map